import { render, staticRenderFns } from "./equipment_point_edit.vue?vue&type=template&id=6d5cf288&scoped=true"
import script from "./equipment_point_edit.vue?vue&type=script&lang=js"
export * from "./equipment_point_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5cf288",
  null
  
)

export default component.exports